import React from "react";
import PropTypes from "prop-types";
import { Badge } from "@opendate-app/setlist";

export const countOrUndefined = (n) => (Number(n) > 0 ? n : undefined);

const CountBadge = ({ count, color = "brand", size = "sm", ...rest }) => {
  const value = Number(count);
  if (!Number.isFinite(value) || value <= 0) return null;
  return <Badge color={color} size={size} {...rest}>{value.toLocaleString()}</Badge>;
};

CountBadge.propTypes = {
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  size: PropTypes.string,
};

export default CountBadge;
